import { render, staticRenderFns } from "./loud.vue?vue&type=template&id=0aa9ffff&scoped=true"
import script from "./loud.vue?vue&type=script&lang=js"
export * from "./loud.vue?vue&type=script&lang=js"
import style0 from "./loud.vue?vue&type=style&index=0&id=0aa9ffff&prod&lang=css"
import style1 from "./loud.vue?vue&type=style&index=1&id=0aa9ffff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9ffff",
  null
  
)

export default component.exports